import { ifLinks, mmLinks } from 'constants/links';
import Button from 'honeydew/Button';
import useAuth from 'hooks/useAuth';
import useGlobalStore from 'hooks/useGlobalStore';
import SEO from 'shared/SEO';

function NoMatchPage() {
    const { authStatus } = useAuth();
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <section className="mt-[80px] bg-[#f2ebd1] px-40 py-40 text-center md:py-[100px]">
            <SEO noIndex />
            <img className="mx-auto" src="https://img-cdn.misfitsmarket.com/images/404error.gif" alt="404" />
            <p className="text-body-md">
                Uh oh, that’s no gourd. This link no longer exists. We’re sorry, let’s try something else.
            </p>
            <div className="mx-auto mt-30 gap-20 md:flex md:w-[500px]">
                <div className="md:w-1/2">
                    {authStatus === 'authenticated' && (
                        <Button as="link" variant="secondary" size="md" to="/account">
                            Go Home
                        </Button>
                    )}
                    {authStatus !== 'authenticated' && (
                        <Button as="link" variant="secondary" size="md" to="/">
                            Go Home
                        </Button>
                    )}
                </div>
                <div className="mt-10 md:mt-0 md:w-1/2">
                    <Button
                        as="a"
                        size="md"
                        href={isMisfitsTheme ? mmLinks.helpCenter : ifLinks.helpCenter}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Visit Help Center
                    </Button>
                </div>
            </div>
        </section>
    );
}

export { NoMatchPage as Component };
